export default class DailyMenuOptionOffer {
  private constructor (
    readonly id: string,
    readonly foodItem: any,
    readonly price: string,
    readonly portionsCount: number,
    readonly reservedPortionsCount: number,
    readonly allergens: [],
    public amount: number


) {}


  static createFromResponse (responseData: any): DailyMenuOptionOffer | undefined {

    if( !responseData )
      return undefined

    return new DailyMenuOptionOffer(
      responseData.id,
      responseData.foodItem,
      responseData.price,
        responseData.portionsCount,
        responseData.reservedPortionsCount,
        responseData.allergens,
        responseData.amount ? responseData.amount : 1
    )
  }
}
